import { render, staticRenderFns } from "./GraficoEstadosV1.vue?vue&type=template&id=18f875a5&scoped=true"
import script from "./GraficoEstadosV1.vue?vue&type=script&lang=js"
export * from "./GraficoEstadosV1.vue?vue&type=script&lang=js"
import style0 from "./GraficoEstadosV1.vue?vue&type=style&index=0&id=18f875a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f875a5",
  null
  
)

export default component.exports